import { useQuery } from 'react-query';

import { PublicApplicationAPI } from '@lib/api/endpoints/Applications';
import { JobsBoardModalFilters } from '@views/jobsBoard/context';

import {
  buildPayloadSearchFilters,
  JOBS_BOARD_POSTS_PUBLIC_QUERY_KEY,
} from '../utils';

export const useGetJobsBoardPostsPublic = (
  jobsBoardSearchFilters: JobsBoardModalFilters,
  publicViewCountry: ProductionCountry
) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [
      JOBS_BOARD_POSTS_PUBLIC_QUERY_KEY,
      jobsBoardSearchFilters,
      publicViewCountry,
    ],
    queryFn: () => {
      const payload = buildPayloadSearchFilters(jobsBoardSearchFilters);
      return PublicApplicationAPI.getJobsBoardPostsPublic(
        payload,
        publicViewCountry
      );
    },
  });

  return {
    data,
    isLoading,
    isError,
    refetch,
  };
};
export type JobsBoardPostsPublicResult = ReturnType<
  typeof useGetJobsBoardPostsPublic
>;
